import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { OrderedMap, List } from 'immutable';

import Ticket from 'models/ticket';
import UserModel from 'models/user';
import { ParkingPass as ParkingPassModel } from 'models/parking-passes';
import {
  SCAN_CODE_METHOD,
  LICENSE_PLATE_METHOD,
  GATE_BUTTON_METHOD,
  PRINTED_PASS_METHOD,
  BLE_FLASH,
  ALL_METHODS,
} from 'models/validation';

import * as AppContext from 'lib/app-context';
import LicensePlateSection from 'components/parking-passes/validation-section/license-plate-section';
import ScanCode from 'components/parking-passes/validation-section/scan-code';
import GateButton from 'components/parking-passes/validation-section/gate-button';

const defaultMethods = [ALL_METHODS];

const ValidationMethod = ({ methods, appContext, ticket, parkingPass, vehicles, user, addVehicle, openGate, changeModalState, addMessage, usejs, color, booking }) => {
  const { validation } = parkingPass;
  const validationMethods = [];
  const { requiredMethods, optionalMethods, gateTechnologies = List() } = validation;
  const isMobile = appContext === AppContext.MOBILE;

  const isMethodIncluded = (method) => {
    if (methods === defaultMethods) return true;

    return methods.includes(method);
  }

  if (requiredMethods.get(GATE_BUTTON_METHOD) && !gateTechnologies.includes(BLE_FLASH) && isMethodIncluded(GATE_BUTTON_METHOD)) {
    validationMethods.push(
      <GateButton
        parkingPass={parkingPass}
        openGate={openGate}
        changeModalState={changeModalState}
        addMessage={addMessage}
        key="gate-button-method"
      />,
    );
  }

  if (requiredMethods.get(PRINTED_PASS_METHOD) && isMethodIncluded(PRINTED_PASS_METHOD)) {
    validationMethods.push(
      <div className="validation-box text-color-dark-slate" key="pass-number-method">
        <h5 className="h5-sg text-color-dark-slate without-vertical-margin text-center">
          <FormattedMessage
            id="parking-pass.how-to-park-validation"
            defaultMessage="Follow instructions in &ldquo;How to Park&rdquo; to validate your pass."
          />
        </h5>
      </div>,
    );
  }

  if ((requiredMethods.get(SCAN_CODE_METHOD) || optionalMethods.get(SCAN_CODE_METHOD)) && isMethodIncluded(SCAN_CODE_METHOD)) {
    validationMethods.push(
      <ScanCode
        parkingPass={parkingPass}
        color={color}
        usejs={usejs}
        key="scan-code-method"
      />,
    );
  }

  if (requiredMethods.get(LICENSE_PLATE_METHOD) && isMethodIncluded(LICENSE_PLATE_METHOD)) {
    validationMethods.push(
      <LicensePlateSection
        appContext={appContext}
        parkingPass={parkingPass}
        addVehicle={addVehicle}
        vehicles={vehicles}
        ticket={ticket}
        user={user}
        addMessage={addMessage}
        key="license-plate-method"
      />,
    );
  }

  if (booking && booking.spaceIdentifier && isMobile) {
  validationMethods.push( <h4 key="space-number" className="align-center col-xs-12 h5-sg line-height-extra margin-top-0 text-color-dark-slate-lte-sm text-weight-bold">
    <FormattedMessage
      id="parking-pass.space-number"
      defaultMessage="Space Number: "
    />
    {booking.spaceIdentifier}
  </h4>)
  }

  return <div>{validationMethods}</div>;
}

ValidationMethod.propTypes = {
  color: PropTypes.string.isRequired,
  parkingPass: PropTypes.instanceOf(ParkingPassModel).isRequired,
  vehicles: PropTypes.instanceOf(OrderedMap).isRequired,
  ticket: PropTypes.instanceOf(Ticket),
  user: PropTypes.instanceOf(UserModel).isRequired,
  addVehicle: PropTypes.func.isRequired,
  openGate: PropTypes.func.isRequired,
  changeModalState: PropTypes.func.isRequired,
  addMessage: PropTypes.func.isRequired,
  usejs: PropTypes.bool.isRequired,
  appContext: PropTypes.string.isRequired,
  methods: PropTypes.arrayOf(PropTypes.string),
};

ValidationMethod.defaultProps = {
  methods: defaultMethods,
}

export default ValidationMethod;
